module.exports = __webpack_public_path__ + "img/xuanran.20ebc4f5.png";